__turbopack_context__.v({
  "stack": "HostImageStack-module-scss-module__ow2Qea__stack",
});
